import { render } from "./BackToTop.vue?vue&type=template&id=2e85e71a&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"

import "./BackToTop.vue?vue&type=style&index=0&id=2e85e71a&lang=scss"
import "./BackToTop.vue?vue&type=style&index=1&id=2e85e71a&lang=scss&scoped=true"

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e85e71a"]])

export default __exports__